<template>
    <modal @close="$emit('close', false)" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('attenzione_label').toUpperCase()}}</h5>
        </div>
        <div slot="body">
            {{$t('cambio_locale_carrello_alert')}}
        </div>
        <div slot="footer" class="flex-fill d-flex justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="setCurrentLocale(false)">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="setCurrentLocale(true)">
                {{$t('btn_conferma')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from "./Modal";

    import {mapActions, mapState} from 'vuex';

    export default {
        name: "ModalResetCartConfirm",
        components: {
            Modal
        },
        computed: {
            ...mapState('global', {
                callback: 'modal_cart_reset_callback'
            })
        },
        methods: {
            setCurrentLocale: function (success) {
                this.callback(success);

                this.showModalCartReset({
                    show: false,
                    callback: () => {
                    }
                });
            },
            ...mapActions('global', [
                'showModalCartReset'
            ])
        }
    }
</script>
